import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const EditRankDialog = ({ player, onClose, onSave }) => {
  const [value, setValue] = useState("");
  useEffect(() => { setValue(player?.rank_override ?? player?.national_rank ?? ""); }, [player]);
  if (!player) return null;
  const pinned = player.rank_override != null;
  return (
    <Dialog open={!!player} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="edit-rank-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-tight">Edit Rank · {player.first_name} {player.last_name}</DialogTitle>
          <DialogDescription>
            Currently #{player.national_rank ?? "—"} nationally{pinned ? ` (pinned to #${player.rank_override})` : " (by rating)"}. Pinning places this player in that exact national slot; everyone else shifts around them.
          </DialogDescription>
        </DialogHeader>
        <label className="label-overline text-[#0A192F]" htmlFor="edit-rank-input">Pin to national rank #</label>
        <input id="edit-rank-input" data-testid="edit-rank-input" type="number" min="1" value={value}
          onChange={(e) => setValue(e.target.value)}
          className="w-full px-3 py-2 border border-slate-300 rounded-sm text-lg font-data" />
        <div className="flex gap-2 justify-end mt-2">
          {pinned && (
            <button data-testid="edit-rank-clear" onClick={() => onSave(player, null)}
              className="px-4 py-2 text-xs font-semibold uppercase tracking-wider border border-slate-300 rounded-sm hover:bg-slate-50">
              Remove Pin
            </button>
          )}
          <button data-testid="edit-rank-save" disabled={!value || Number(value) < 1} onClick={() => onSave(player, Number(value))}
            className="px-4 py-2 text-xs font-semibold uppercase tracking-wider bg-[#E63946] text-white rounded-sm disabled:opacity-50">
            Pin Rank
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
